import dayjs from "dayjs";
import { NonProductionDays } from "us.collection.admin/functions";
import { smsTime } from "us.collection.admin/functions";
import { IInitialState } from "../Interfaces";

const selectedYear = dayjs().year();

export const initialState: IInitialState = {
  calendar: {
    data: {
      calendarId: -1,
      calendarName: "",
      selectedYear: selectedYear,
      startDate: dayjs.utc(`${selectedYear}-01-01`),
      endDate: dayjs.utc(`${selectedYear}-12-31`),
      selectedCriteria: "NonBanking",
      previousCalendars: [],
      isImported: false,
    },
    isFetching: false,
  },
  calendars: {
    data: [],
    isFetching: false,
  },
  redDays: {
    data: {
      nonProductionDays: NonProductionDays.call(selectedYear),
      selectedNonProductionDate: null,
    },
    isFetching: false,
  },
  smsSchedule: {
    data: smsTime.call(selectedYear),
    isFetching: false,
  },
};
